import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import { LoaderCircle } from 'lucide-react';

interface ChangePersonalisationModalProps {
  open: boolean;
  onGoBack: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

export default function RemovePersonalisationDataModal({
  open,
  onGoBack,
  onConfirm,
  isSubmitting,
}: ChangePersonalisationModalProps) {
  return (
    <AlertDialogPrimitive.Root open={open}>
      <AlertDialogPrimitive.Portal>
        <AlertDialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/60 backdrop-blur-[2px]" />

        <AlertDialogPrimitive.Content className="fixed left-1/2 top-1/2 z-[51] w-[calc(100%_-_32px)] max-w-[430px] -translate-x-1/2 -translate-y-1/2 bg-background px-[22px] py-[26px] outline-none sm:px-[30px] sm:py-[30px]">
          <AlertDialogPrimitive.Title className="mt-[8px] text-[28px] text-center font-bold leading-[33px] sm:text-[32px] sm:leading-[37px]">
            Are you sure?
          </AlertDialogPrimitive.Title>

          <div className="my-[22px] border-t border-dashed border-[#e5e5e5]" />

          <AlertDialogPrimitive.Description asChild>
            <div className="font-[Arial] font-normal text-foreground text-[clamp(14px,1.5vw,18px)]">
              We will remove the link between your saved personalisation and your email address and/or telephone number
              and they will not be available for future use.
            </div>
          </AlertDialogPrimitive.Description>

          <div className="mt-[28px] flex flex-row gap-[12px] sm:flex-row sm:items-center sm:justify-between sm:gap-[20px] relative">
            <AlertDialogPrimitive.Action asChild>
              <button
                className="button-screwfix-danger flex h-[48px] min-h-32 flex-1 items-center justify-center gap-[9px] px-[20px] [font-family:archivo_narrowbold,sans-serif] text-[clamp(18px,calc(16px_+_0.3vw),19px)] font-bold text-primary-foreground disabled:pointer-events-none disabled:opacity-60"
                disabled={isSubmitting}
                onClick={onConfirm}
                type="submit"
              >
                {isSubmitting ? <LoaderCircle aria-hidden="true" className="h-[18px] w-[18px] animate-spin" /> : null}
                {isSubmitting ? 'Removing..' : 'Remove'}
              </button>
            </AlertDialogPrimitive.Action>
            <AlertDialogPrimitive.Cancel asChild>
              <button
                className="button-screwfix-secondary flex flex-1 h-[48px] w-full items-center justify-center !px-[22px] [font-family:archivo_narrowbold,sans-serif] !text-[clamp(18px,calc(16px_+_0.3vw),19px)] font-bold focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/30 disabled:pointer-events-none disabled:opacity-60 sm:min-w-[150px] sm:w-auto"
                onClick={onGoBack}
                disabled={isSubmitting}
                type="button"
              >
                Cancel
              </button>
            </AlertDialogPrimitive.Cancel>
          </div>
        </AlertDialogPrimitive.Content>
      </AlertDialogPrimitive.Portal>
    </AlertDialogPrimitive.Root>
  );
}
